/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BabylonProposalTimeInfo } from './BabylonProposalTimeInfo';

export type BabylonProposalDepositPeriodInfo = {
    PPLID: string;
    EXP: BabylonProposalDepositPeriodInfo.EXP;
    TTL: string;
    TPLIST: Array<string>;
    TDPST: string;
    DPSTT: BabylonProposalTimeInfo;
};

export namespace BabylonProposalDepositPeriodInfo {

    export enum EXP {
        Y = 'Y',
        N = 'N',
    }


}

